import React from "react";
import "./footer.css";
import styled from "styled-components";

const StyledWrapper = styled.div`
  ul {
    list-style: none;
    display: flex;
    alignitems: left;
    margin-top: 10%;
    padding-left: 0px;
  }

  .example-2 {
    display: flex;
    justify-content:left;
    align-items: center;
    flex-direction: row;
   
    
  }
  @media screen and (min-width:350px) and (max-width:760px){
    .example-2{
      display: flex;
      justify-content:center;
      align-items: center;
      flex-direction: row;
      margin-left:10px;
    }
    }

  @media screen and(min-width:790px)  and (max-width:1250px){
  .example-2 {
    display: flex;
    justify-content:left;
    align-items: center;
    flex-direction: row;
  }
  }

  .example-2 .icon-content {
    margin: 0 3px;
    position: relative;
    padding: 0.1rem;
  }

  .example-2 .icon-content .tooltip {
    position: absolute;
    bottom: -35px;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    padding: 6px 10px;
    border-radius: 5px;
    opacity: 0;
    visibility: hidden;
    font-size: 14px;
    transition: all 0.3s ease;
    background-color: rgba(0, 0, 0, 0.7);
    white-space: nowrap;
  }

  .example-2 .icon-content:hover .tooltip {
    opacity: 1;
    visibility: visible;
    bottom: -45px;
  }

  .example-2 .icon-content a {
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    color: #4d4d4d;
    background-color: #fff;
    transition: all 0.3s ease-in-out;
  }

  .example-2 .icon-content a:hover {
    box-shadow: 3px 2px 45px 0px rgb(0 0 0 / 12%);
  }

  .example-2 .icon-content a svg {
    position: relative;
    z-index: 1;
    width: 30px;
    height: 30px;
  }

  .example-2 .icon-content a:hover {
    color: white;
  }

  .example-2 .icon-content a .filled {
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0;
    background-color: #000;
    transition: all 0.3s ease-in-out;
  }

  .example-2 .icon-content a:hover .filled {
    height: 100%;
  }

  .example-2 .icon-content a[data-social="linkedin"] .filled,
  .example-2 .icon-content a[data-social="linkedin"] ~ .tooltip {
    background-color: #0274b3;
  }

  .example-2 .icon-content a[data-social="github"] .filled,
  .example-2 .icon-content a[data-social="github"] ~ .tooltip {
    background-color: #24262a;
  }

  .example-2 .icon-content a[data-social="instagram"] .filled,
  .example-2 .icon-content a[data-social="instagram"] ~ .tooltip {
    background: linear-gradient(
      45deg,
      #405de6,
      #5b51db,
      #b33ab4,
      #c135b4,
      #e1306c,
      #fd1f1f
    );
  }

  .example-2 .icon-content a[data-social="youtube"] .filled,
  .example-2 .icon-content a[data-social="youtube"] ~ .tooltip {
    background-color: #ff0000;
  }

  /* Additional styling for tooltips and icons */
  .example-2 .icon-content a[data-social="facebook"] .filled,
  .example-2 .icon-content a[data-social="facebook"] ~ .tooltip {
    background-color: #3b5998;
  }

  .example-2 .icon-content a[data-social="linkedin"]:hover,
  .example-2 .icon-content a[data-social="github"]:hover,
  .example-2 .icon-content a[data-social="instagram"]:hover,
  .example-2 .icon-content a[data-social="youtube"]:hover,
  .example-2 .icon-content a[data-social="facebook"]:hover {
    transform: scale(1.1);
  }
`;

const Footer = () => {
  return (
    <footer className="bg-light text-center text-lg-start text-muted">
      <div className="mainfooter">
        <section>
          <div className="container text-center text-md-start mt-5">
            <div className="row mt-3">
              <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">
                  Aspiron Technologies
                </h6>

                <p className="mb-1 ">
                  <b>Address:</b>
                </p>
                <p className="mb-4">
                  Floor 6B-C, Bizness square Building, Opposite Hitex Kaman,
                  Hitech City Rd, Laxmi Cyber City, White fields, HITEC City,
                  Hyderabad, Telangana 500081
                </p>

                <p className="mb-1">
                  <b>Map</b>
                </p>
                <div
                  className="map-container"
                  style={{
                    borderRadius: "10px",
                    overflow: "hidden",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    margin: "10px auto",
                    maxWidth: "600px",
                    width: "100%",
                    height: "200px",
                    border: "1px solid #ccc",
                  }}
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.067589399075!2d78.37377627492091!3d17.456478800811574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93da776e3347%3A0xd43f52aa73cb4014!2sBizness%20Square!5e0!3m2!1sen!2sin!4v1732706343266!5m2!1sen!2sin"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "0",
                    }}
                     title="Google Map"
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
              <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Useful links</h6>

                <p className="mb-2 footerHover">
                  <a href="./careers" className="text-reset footerHover">
                    Careers
                  </a>
                </p>

                <p className="mb-2 footerHover">
                  <a href="./terms" className="text-reset">
                    Terms and Conditions
                  </a>
                </p>
                <p className="mb-2 footerHover">
                  <a href="./privacy" className="text-reset">
                    Privacy Policy
                  </a>
                </p>
              </div>
              <div className="col-md-6 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
                <p className="mb-3 ">
                  Explore What We Provide: <br />
                  <b>
                    <a href="mailto:aditya@aspiron.in " className="footerHover">
                      <i
                        class="fas fa-envelope "
                        style={{ paddingRight: "10px" }}
                      ></i>
                      aditya@aspiron.in
                    </a>
                  </b>
                </p>
                <p className="mb-3 ">
                  Explore your future with us: <br />
                  <b>
                    <a href="mailto:hr@aspiron.in" className="footerHover">
                      <i
                        class="fas fa-envelope "
                        style={{ paddingRight: "10px" }}
                      ></i>
                      hr@aspiron.in
                    </a>
                  </b>
                </p>
                <p className="mb-3 ">
                  Product Insights:
                  <br />
                  <b>
                    <a href="tel:+918142229998">
                      <p className="footerHover">
                        <i
                          class="fas fa-mobile-alt"
                          style={{ paddingRight: "10px" }}
                        ></i>
                        8142229998
                      </p>
                    </a>
                    {/* <p className="mb-3">
                      Follow us on: <br />
                      <b>
                        <a
                          href="https://www.instagram.com/theofficial_aspirontech/"
                          className="me-3 text-reset text-decoration-none"
                          target="_blank"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="whitesmoke"
                            className="bi bi-instagram"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                          </svg>
                        </a>
                        <a
                          href="https://www.facebook.com/Adiversetechnologies/"
                          className="me-3 text-reset text-decoration-none"
                          target="_blank"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="whitesmoke"
                            className="bi bi-facebook"
                            viewBox="0 0 16 16"
                          >
                            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                          </svg>
                        </a>

                        <a
                          href="https://www.linkedin.com/company/aspiron-technologies"
                          className="me-3 text-reset text-decoration-none"
                          target="_blank"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="whitesmoke"
                            className="bi bi-linkedin"
                            viewBox="0 0 16 16"
                          >
                            <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                          </svg>
                        </a>
                        <a
                          href="https://www.youtube.com/channel/UCEKYx_vVgXPF4mbK-2XYgfw"
                          className="text-reset text-decoration-none"
                          target="_blank"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="26"
                            fill="whitesmoke"
                            className="bi bi-youtube"
                            viewBox="0 0 16 14"
                          >
                            <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                          </svg>
                        </a>
                      </b>
                    </p> */}
                    <StyledWrapper>
                      <ul className="example-2">
                        <li className="icon-content">
                          <a
                            href="https://www.linkedin.com/company/aspiron-technologies"
                            aria-label="LinkedIn"
                            data-social="linkedin"
                          >
                            <div className="filled" />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={16}
                              height={16}
                              fill="currentColor"
                              className="bi bi-linkedin"
                              viewBox="0 0 16 16"
                              xmlSpace="preserve"
                            >
                              <path
                                d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"
                                fill="currentColor"
                              />
                            </svg>
                          </a>
                          <div className="tooltip">LinkedIn</div>
                        </li>
                        <li className="icon-content">
                          <a
                            href="https://www.instagram.com/official_aspiron.ai/"
                            aria-label="Instagram"
                            data-social="instagram"
                          >
                            <div className="filled" />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={16}
                              height={16}
                              fill="currentColor"
                              className="bi bi-instagram"
                              viewBox="0 0 16 16"
                              xmlSpace="preserve"
                            >
                              <path
                                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"
                                fill="currentColor"
                              />
                            </svg>
                          </a>
                          <div className="tooltip">Instagram</div>
                        </li>
                        <li className="icon-content">
                          <a
                            href="https://www.youtube.com/channel/UCEKYx_vVgXPF4mbK-2XYgfw"
                            aria-label="YouTube"
                            data-social="youtube"
                          >
                            <div className="filled" />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={16}
                              height={16}
                              fill="currentColor"
                              className="bi bi-youtube"
                              viewBox="0 0 16 16"
                              xmlSpace="preserve"
                            >
                              <path
                                d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z"
                                fill="currentColor"
                              />
                            </svg>
                          </a>
                          <div className="tooltip">YouTube</div>
                        </li>
                        <li className="icon-content">
                          <a
                            href="https://www.facebook.com/theofficialaspirontech"
                            aria-label="Facebook"
                            data-social="facebook"
                          >
                            <div className="filled" />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={16}
                              height={16}
                              fill="currentColor"
                              className="bi bi-facebook"
                              viewBox="0 0 16 16"
                              xmlSpace="preserve"
                            >
                              <path
                                d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm2.58 8.54h-1.45v6.25H8.65V8.54H7.2v-1.53h1.46V5.66c0-.9.25-1.56 1.62-1.56h1.23v1.5H9.99c-.55 0-.64.26-.64.61v1.52h1.49l-.18 1.53z"
                                fill="currentColor"
                              />
                            </svg>
                          </a>
                          <div className="tooltip">Facebook</div>
                        </li>
                      </ul>
                    </StyledWrapper>
                  </b>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div></div>

      <div
        className="text-center p-4"
        style={{
          backgroundColor: "black",
          color: "whitesmoke",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <hr style={{ border: "1px solid white", margin: "20px 0" }} />

        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="foter_copyrights"
        >
          <p style={{ margin: "0" }}>© 2024 Copyright: All rights reserved.</p>
          <p style={{ margin: "0" }}>
            Design & developed by
            <a href="https://adiversetech.com/" target="_blank" rel="noreferrer">
              ADIVERSE
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
